import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import GoogleLoginPlugin from 'vue3-google-login'
// import VueCookieConsent from 'vue-cookieconsent';
// import 'vue-cookieconsent/dist/vue-cookieconsent.css';

createApp(App).use(router).use(GoogleLoginPlugin, {
    clientId: '15230148762-uphu0dn4p0h8pmrmpjvkfggb25jj3gi6.apps.googleusercontent.com',
  }).mount('#app')
